<template>
  <div v-if="content || $slots.default" class="form-row">
    <label class="col-sm-4 col-form-label">
      {{ title }} <span class="float-right">:</span>
    </label>
    <div class="col-sm-8">
      <p class="form-control-plaintext f12">
        <template v-if="!$slots.default"> {{ content }} </template>
        <slot></slot>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    content: String
  }
}
</script>
<style scoped></style>
